import React, { CSSProperties, FC } from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';


export interface OptionButton {
    id: number;
    nome: string;
}

export interface AttributesButton {
    nome: string;
    options: OptionButton[];
    handleClickButton?: Function;
    containerStyles?: CSSProperties;
}

const FilterButton: FC<AttributesButton> = ({
    nome,
    options,
    handleClickButton = () => {},
    containerStyles,
}) => {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLDivElement>(null);
  const [selectedIndex, setSelectedIndex] = React.useState(0);

  const handleClick = () => {
    if (handleClickButton) {
      handleClickButton(options.map((opt)=> {return opt.id}), nome, "Todos");
    }
  };

  const handleMenuItemClick = (
    event: React.MouseEvent<HTMLLIElement, MouseEvent>,
    index: number,
  ) => {
    setSelectedIndex(index);
    setOpen(false);
    if (handleClickButton) {
        handleClickButton([options[index].id], nome, options[index].nome);
        /*if (index !== 0) {
          handleClickButton([options[index].id], nome, options[index].nome);
        } else {
          handleClickButton(options.map((opt)=> {return opt.id}), nome, "Todos");
        }*/
    }
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event?: MouseEvent | TouchEvent) => {
    const target = event?.target as HTMLElement | null;
    if (anchorRef.current && anchorRef.current.contains(target)) {
      return;
    }

    setOpen(false);
  };

  return (
    <Grid container direction="column" alignItems="center" style={containerStyles}>
      <Grid size={12}>
        <ButtonGroup variant="contained" color="primary" ref={anchorRef} aria-label="split button">
          <Button onClick={handleClick}>{nome}</Button>
          <Button
            color="primary"
            size="small"
            aria-controls={open ? 'split-button-menu' : undefined}
            aria-expanded={open ? 'true' : undefined}
            aria-label="select merge strategy"
            aria-haspopup="menu"
            onClick={handleToggle}
          >
            <ArrowDropDownIcon />
          </Button>
        </ButtonGroup>
        <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList id="split-button-menu">
                    {options.map((option, index) => (
                      <MenuItem
                        key={option.nome}
                        // disabled={index === 2}
                        selected={index === selectedIndex}
                        dense
                        onClick={(event) => handleMenuItemClick(event, index)}
                      >
                        {option.nome}
                      </MenuItem>
                    ))}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </Grid>
    </Grid>
  );
}

export { FilterButton }
